<div *ngIf="!editing; else editForm" class="game-recap-public--display-container">
	<div class="game-recap-public--images">
		<app-image-carousel *ngIf="!imageLoading; else loadMsg" [images]="approved"></app-image-carousel>
	</div>
	<div class="game-recap-public--blog-score">
		<div *ngIf="shift.recap" class="game-recap-public--blog-viewer" [innerHTML]="shift.recap | safeHtml">
			<p>No recap written yet...</p>
		</div>
		<div *ngIf="!shift.recap" class="game-recap-public--blog-viewer">
			<p>No recap written yet...</p>
		</div>
		<div *ngIf="!game.use_external_app">
			<div class="game-recap-public--header">
				<div class="game-recap-public--rank">Rank</div>
				<div class="game-recap-public--team-id">Team ID</div>
				<div class="game-recap-public--team-name">Team Name</div>
				<div class="game-recap-public--score">Score</div>
			</div>
			<div class="game-recap-public--row" *ngFor="let t of tDisplay; let i = index">
				<div class="game-recap-public--rank">{{t.rank}}</div>
				<div class="game-recap-public--team-id">{{t.kt_team_id}}</div>
				<div class="game-recap-public--team-name">{{t.team_name}}</div>
				<div class="game-recap-public--score">{{t.score}}</div>
			</div>
		</div>
	</div>
</div>

<ng-template #editForm>
	<div *ngIf="!loading; else loadMsg">
		<div class="game-recap-public--content">
			<div class="game-recap-public--image-edit">
				<app-image-list
					[game]="game"
					[user]="user"
					[images]="images"
					(newImages)="addImages($event)"
					(setBusy)="busyUpload = $event"></app-image-list>
			</div>
			<div class="game-recap-public--blog-score">
				<div class="game-recap-public--blog">

          <quill-editor
            class="content-editor"
            [modules]="quillModules"
            [(ngModel)]="recap.recap"
            placeholder="Write the game recap here..."
            style="height: 200px; width: 700px;display: inline-block;"
            [maxLength]="maxCharacters"
            (onEditorCreated)="onEditorCreated($event)"
            >
          </quill-editor>


            <p [ngStyle]="{ color: (characterCount >= maxCharacters) ? 'red' : 'inherit' }">
              Remaining characters: {{ (maxCharacters - characterCount) | number:'1.0-0' }}
            </p>

				</div>
				<div *ngIf="!game.use_external_app" class="game-recap-public--teams">
					<app-team-management *ngIf="game.status === 'ended'; else noScoreEdit" [game]="game" [noWS]="true"></app-team-management>
				</div>
			</div>
		</div>
		<div *ngIf="!busyUpload" class="hrz-between">
			<button class="recap-ctrl-red" (click)="cancel()">Cancel</button>
			<button class="recap-ctrl-green" (click)="saveRecap()">Save</button>
		</div>
	</div>
</ng-template>

<ng-template #loadMsg>
	<div>
		<h3 class="center-text">Updating your Recap. One moment...</h3>
	</div>
</ng-template>

<ng-template #imgLoadMsg>
	<div>
		<h3 class="center-text">Loading Images...</h3>
	</div>
</ng-template>

<ng-template #noScoreEdit>
	<div>
		<h3 class="center-text">Final scores cannot be edited while game is still live.</h3>
	</div>
</ng-template>
